
import React from "react";

interface StatTileProps {
    icon: string;
    label: string;
    value?: React.ReactNode;
    accent?: string;
}

export const StatTile: React.FC<StatTileProps> = ({
    icon,
    label,
    value,
    accent = "#4f46e5",
}) => (
    <div
        style={{
            textAlign: "center",
            padding: "0 16px",
            borderRight: "1px solid #f0f0f8",
        }}
    >
        <i
            className={`ti ${icon} d-block mb-1`}
            style={{ fontSize: 17, color: accent }}
        />
        <div
            style={{ fontSize: 14, fontWeight: 700, color: "#0f172a", lineHeight: 1.2 }}
        >
            {value ?? <span style={{ color: "#e2e8f0" }}>—</span>}
        </div>
        <div
            style={{
                fontSize: 10,
                color: "#94a3b8",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                marginTop: 2,
            }}
        >
            {label}
        </div>
    </div>
);


interface ContactItemProps {
    icon: string;
    label: string;
    value?: React.ReactNode;
    accent?: string;
    href?: string;
}

export const ContactItem: React.FC<ContactItemProps> = ({
    icon,
    label,
    value,
    accent = "#64748b",
    href,
}) => {
    const inner = (
        <div className="d-flex align-items-center gap-2 flex-shrink-0">
            <div
                className="d-flex align-items-center justify-content-center rounded-2 flex-shrink-0"
                style={{ width: 28, height: 28, background: `${accent}12` }}
            >
                <i className={`ti ${icon}`} style={{ fontSize: 13, color: accent }} />
            </div>
            <div>
                <div
                    style={{
                        fontSize: 9,
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        color: "#b0bec5",
                        lineHeight: 1,
                    }}
                >
                    {label}
                </div>
                <div
                    style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#334155",
                        marginTop: 1,
                        lineHeight: 1.2,
                    }}
                >
                    {value ?? <span style={{ color: "#e2e8f0" }}>—</span>}
                </div>
            </div>
        </div>
    );

    return href ? (
        <a href={href} style={{ textDecoration: "none" }}>
            {inner}
        </a>
    ) : (
        inner
    );
};